/*
 * changePassword Actions
 *
 * @version 1.0.0
 * @author Magarelli-Fabrizio
 * @since 19-Sep-2024
 */

import { createRequestTypes, createAction, MakeRequest } from './index'

export const actionTypes = {
  DO_CHANGE_PASSWORD: '@@changePassword/change_password',
  DO_RESET_SHOW_RESULT: '@@changePassword/reset_show_result',
  // @generator action:type
  ...createRequestTypes('@@changePassword', 'SAVE_PASSWORD')
  // @generator action:type:request
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:request
/** @action request
 * * Insert a description
 * @name savePassword
 * @return {object} - The action object
 */
export const savePassword = new MakeRequest('changePassword', 'save_password')
// @generator action
/** @action
 * * Insert a description
 * @name ResetShowResult
 * @return {object} - The payload object
 */
export const doResetShowResult = (payload) => createAction(actionTypes.DO_RESET_SHOW_RESULT, { payload })
/** @action
 * * Insert a description
 * @name ChangePassword
 * @return {object} - The payload object
 */
export const doChangePassword = (payload) => createAction(actionTypes.DO_CHANGE_PASSWORD, { ...payload })
